module.exports = __webpack_public_path__ + "static/oefentherapie-1-156ca26230e721f713d42ff7526ad53f.jpg";